module.exports = __webpack_public_path__ + "img/man.934f0557.png";